import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { ActivatedRoute } from '@angular/router';

@Component({ 
  standalone: false, 
  selector: 'app-review-connect',
   templateUrl: './review-connect.component.html', 
   styleUrl: './review-connect.component.scss' })
export class ReviewConnectComponent {

   @Input() stepDetails: any;
    @Output() routeConfig: EventEmitter<any> = new EventEmitter();
    @Input() step: any;
    payload: any;
    showUploadDocument = false;
    
    isSubmitting = false;
  
    constructor(
      private fb: FormBuilder,
      private messageService: MessageService,
      private api: ApiService,
      private route: ActivatedRoute
    ) {}
  
    ngOnInit(): void {
      
  
      this.route.queryParams.subscribe(params => {
    console.log("scheme_id", params['scheme_id']);
    console.log("proposal_id", params['proposal_id']);
  });
    }
    isAonOpen = true;
  proposalName = "Idex 4 Fauji";

  addActionPoint() {
    console.log("Add Action Point Clicked");
  }

  submitReview() {
    console.log("Submitted for review");
  }
  openUploadDocument() {
  this.showUploadDocument = true;
}

}